import React from 'react';
import { useTranslation } from 'react-i18next';
import Money from '../Common/Money/Money';

import { skeletonLoadingBalanceLast7Days } from '../Skeletons/SkeletonAccount';
import { useSelector } from 'react-redux';

const PaymentBalance = ({ todayBalance, loading }) => {
  const { t } = useTranslation();
  const currency = useSelector((state) => state.currency.default);
  return (
    <div className='card associate-balance position-relative px-3 py-2'>
      <div className='d-flex'>
        <div className='text-lighter-gray font-1rem fw-extrabold'>{t('today')}</div>
      </div>
      <div className='row balance mt-1'>
        <div className='col-6 pr-2'>
          <div className='text-secondary font-1rem  mb-2'>
            {t('grossVolume')} <span className='fw-300 font-tiny'>({currency?.shortForm})</span>
          </div>

          <span className='font-extra-large'>
            {!loading ? (
              <div className='fade-up'>
                <Money value={todayBalance?.amount} symbolSize='.85rem' />
              </div>
            ) : (
              skeletonLoadingBalanceLast7Days()
            )}
          </span>
        </div>
        <div className='col-6 p-0 pl-2' style={{ borderLeft: '1px solid #212121' }}>
          <div className='text-secondary font-1rem  text-capitalize  mb-2'>{t('payments')}</div>
          <span className='font-extra-large'>
            {!loading ? (
              <div className='fade-up'>{todayBalance?.payments}</div>
            ) : (
              skeletonLoadingBalanceLast7Days()
            )}
          </span>
        </div>
      </div>

      {/* {!loading && (
        <div className='fade-up' style={{ position: 'absolute', right: '0px', bottom: '.6rem' }}>
          <ChevronIcon size='1.063rem' fillColor='#fff' />
        </div>
      )} */}
    </div>
  );
};

export default PaymentBalance;
